import { Proxar } from './Proxar';

(window as any).proxar = (window as any).proxar || null;

document.addEventListener('DOMContentLoaded', () => {
    (window as any).proxar = new Proxar();
});